import { render, staticRenderFns } from "./AbbyKioskParticpants.vue?vue&type=template&id=051a0320&"
import script from "./AbbyKioskParticpants.vue?vue&type=script&lang=js&"
export * from "./AbbyKioskParticpants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports